import { ChainTransactionStatus } from '@katanaperps/katana-perps-sdk';
import React, { useEffect, useState } from 'react';

import { fetchWithdrawal } from 'api/apiExchange';
import { ApiWithdrawal } from 'api/types';
import { Chains, WITHDRAWAL_MINED_FETCH_DELAY_MS } from 'config/constants';
import { useSelector } from 'reduxState/store';

import WithdrawalResultErrorModal from './WithdrawalResultErrorModal';

type Props = {
  withdrawalId: string;
  onClose: () => void;
  activeChain: Chains;
};

function WithdrawalResultModal({ withdrawalId, activeChain, onClose }: Props) {
  const walletAddress = useSelector(state => state.wallet.walletAddress);

  const [withdrawal, setWithdrawal] = useState<ApiWithdrawal>();

  useEffect(() => {
    // Some hotfixes because API is delayed, we need to wait a bit before requesting...
    let canceled = false;
    const timeoutId = setTimeout(() => {
      fetchWithdrawal(walletAddress, withdrawalId).then(withdraw => {
        if (canceled) {
          return;
        }
        if (withdraw.katanaTxStatus === 'pending') {
          console.error(
            'API returned pending Withdrawal state, but websocket mined'
          );
          onClose();
          return;
        }
        setWithdrawal(withdraw);
      });
    }, WITHDRAWAL_MINED_FETCH_DELAY_MS);
    return () => {
      canceled = true;
      clearTimeout(timeoutId);
    };
  }, [onClose, walletAddress, withdrawalId]);

  if (!withdrawal) {
    return null;
  }

  const isSuccess = withdrawal.katanaTxStatus === ChainTransactionStatus.mined;
  if (isSuccess) {
    // No need to report success by showing extra modal
    return null;
  }
  return (
    <WithdrawalResultErrorModal
      activeChain={activeChain}
      onClose={onClose}
      withdrawal={withdrawal}
    />
  );
}

export default WithdrawalResultModal;
